<app-alert></app-alert>
<section class="card">
      <div class="card-header">
        <span class="cat__core__title">
            <strong id="pageTitle">MGT-2 Register of Debenture holders / other securities holders </strong>
        </span>  
        <span style="float: right">
          <!-- <a routerLink="/mgt2"> -->
            <button (click)="addMGT2()" class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"
            [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}">
              <i class="fa fa-plus"></i>&nbsp;Add</button>
          <!-- </a>     -->
        </span>
      <!-- 
        <span style="float:right">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
            <span>
              <i class="fa fa-save"></i>Generate Output </span>
          </button>
        </span> -->
      </div>
        <!-- Date Filter  -->
        <section class="card search-box">
          <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
          <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
            <div class="row">
              <div class="col-lg-12">
                  <div class="row">
                      <div class="col-md-3">
                        <label>Debenture Holder Name
                        </label>
                        <div class="input-group">
                          <input type="text" class="form-control" [(ngModel)]='debentureHolderName'>
                        </div>
                        <br>
                      </div>

                      <!-- <div class="col-md-3">
                        <label>Date of cessation as debenture holder/ other security holder</label>
                        <div class="input-group" (click)="$event.stopPropagation()">
                          From Date:&nbsp;
                          <input id="doCessation" class="form-control" [minDate]="futureToDate"
                            style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="doCessation" ngbDatepicker
                            #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="doCessation">
                          <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                            <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                          </button>
                        
                        </div>
                      </div> -->
          
          
                      <!-- <div class="col-md-3">
                        <label>Date of becoming debenture holder/ other security holder</label>
                        <div class="input-group" (click)="$event.stopPropagation()">
                        
                           To Date:&nbsp;
                          <input id="doDebenture" class="form-control" [minDate]="futureToDate"
                          style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="doDebenture" ngbDatepicker
                          #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="doDebenture">
                        <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                        </div>
                      </div> -->

                    <div class="col-md-3">
                     <br>
                        <!-- <label>Date of Loan</label> -->
                        <div class="input-group" (click)="$event.stopPropagation()">
                          
                          From :&nbsp;
                          <input id="doCessation" class="form-control" [minDate]="futureToDate"
                            style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="doCessation" ngbDatepicker
                            #cesDate="ngbDatepicker" (click)="cesDate.toggle();b.close()" [(ngModel)]="doCessation">
                          <button class="input-group-addon" (click)="cesDate.toggle();b.close()" type="button">
                            <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                          </button>
                        </div>
                    </div>


                        <div class="col-md-3">

                          <br>
                          <div class="input-group" (click)="$event.stopPropagation()">
                          
                             To :&nbsp;
                          <input id="doCessationTo" class="form-control" [minDate]="futureToDateTo"
                          style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="doCessationTo" ngbDatepicker
                          #b="ngbDatepicker" (click)="b.toggle();cesDate.close()" [(ngModel)]="doCessationTo">
                        <button class="input-group-addon" (click)="b.toggle();;cesDate.close()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                        </div>
                      </div>
          



                      <div class="col-lg-2 col-md-2 col-sm-2">
                        <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                        <br>
                        <div class="input-group">
                          <button type="button" [disabled]="searchResponse" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                            <i class="fa fa-search"></i>Search</button>
                          &nbsp;&nbsp;&nbsp;
                          <button type="button" [disabled]="searchResponse" class="btn btn-sm btn-default mb-2"
                            (click)="clearAdvSearch()">
                            <i class="fa fa-refresh"></i>Clear</button>
                        </div>
                      </div>
                    </div>
                <!-- <form  (document:click)="cesDate.close()">
                  <div class="row">
                    <div class="col-lg-2">
                      <label>Debenture Holder Name</label>
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input type="text" class="form-control">
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <label>&nbsp;&nbsp;&nbsp;</label>
                      <div class="input-group">
                        <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="getDirectorByParam()">
                          <i class="fa fa-search"></i>Search</button>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2" (click)="getDirectorByNullParam()">
                          <i class="fa fa-refresh"></i>Clear</button>
                      </div>
                    </div>
                  </div>
                </form> -->
              </div>
            </div>
          </div>
        </section>
        <!-- Date filter End -->
        <div class="card-block datatable-card-block">
          <div class="row">
            <div class="col-md-12">
              <div class="margin-bottom-50">
                <div class="table-responsive">
                  <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector" class="table table-hover compact cell-border nowrap stripe"
                    id="mgt2listTable" style="cursor: pointer;">
                    <thead>
                      <tr>
                        <th>Folio Number</th>
                        <th>Debenture Holder<br> Name</th>
                        <th>Address of the<br> Body-Corporate</th>
                        <th>Address of the<br> individual</th>
                        <th>Joint Holder<br> Name</th>
                        <th>Email ID</th>
                        <th>Date of cessation as<br> debenture holder/ <br>other security holder</th>
                        <th>Date of becoming<br> debenture holder/ <br>other security holder</th>
                        <!-- <th>Status</th> -->
                        <th class="actionclass">Action</th>
                      </tr>
                    </thead>
                     <tbody>
                      <tr *ngFor="let director of registerMgt2List;">
                        <td >
                            {{director.folioNumber}}
                        </td>
                        <td *ngIf="director.personal.DocumentManagementID == null"> </td>
                        <td *ngIf="director.personal.holders == 'individual'">
                          {{director.personal.debentureName}}
                        </td>
                        <td *ngIf="director.personal.holders == 'bodyCorporate'">
                            {{director.personal.debentureNameBodyCorporate}}
                        </td>
                        <td *ngIf="director.personal.holders == 'others'">
                            {{director.personal.debentureNameOthers}}
                        </td>
                        <!-- <th *ngIf="director.holders == 'individual'">
                          {{director.debentureName}}
                        </th> -->
                        <td *ngIf="director.personal.DocumentManagementID == null"> </td>
                        <td *ngIf="director.personal.holders == 'individual'">
                            N/A
                        </td>
                        <td *ngIf="director.personal.holders == 'bodyCorporate'">
                            {{director.personal.registeredAddressBodyCorporate}}
                        </td>
                        <td *ngIf="director.personal.holders== 'others'">
                            N/A
                        </td>
                        <td *ngIf="director.personal.DocumentManagementID == null"> </td>
                        <td *ngIf="director.personal.holders == 'individual'">
                            {{director.personal.address}}
                        </td>
                        <td *ngIf="director.personal.holders == 'bodyCorporate'">
                            N/A
                        </td>
                        <td *ngIf="director.personal.holders == 'others'">
                            N/A
                        </td>
                        <td *ngIf="director.personal.DocumentManagementID == null"> </td>
                        <td *ngIf="director.personal.holders == 'individual'">
                            {{director.personal.nameOfJointHolder}}
                        </td>
                        <td *ngIf="director.personal.holders == 'bodyCorporate'">
                            N/A
                        </td>
                        <td *ngIf="director.personal.holders == 'others'">
                            {{director.personal.jointHolderOthers}}
                        </td>
                        <td *ngIf="director.personal.DocumentManagementID == null"> </td>
                        <td *ngIf="director.personal.holders == 'individual'">
                            {{director.personal.emailid}}
                        </td>
                        <td *ngIf="director.personal.holders == 'bodyCorporate'">
                            {{director.personal.emailIdBodyCorporate}}
                        </td>
                        <td *ngIf="director.personal.holders == 'others'">
                            {{director.personal.emailOthers}}
                        </td>
                        <!-- <th>
                          {{director.dateOftitle | date : "dd-MM-y"}}
                        </th> -->
                        <!-- <th>
                            <span *ngIf="director.Status==true">Active</span>
                            <span *ngIf="director.Status==false">Inactive </span>
                          </th> -->

                          <td>
                            <ng-container *ngIf="director.holding">
                            <span *ngIf="director.holding.typesOfHolders=='individual'">{{director.holding.dateOfCessation  | date : "dd-MM-y"}}</span>
                            <span *ngIf="director.holding.typesOfHolders=='bodyCorporate'">{{director.holding.doCessationAsDebentureHolderOtherSecurityHolder  | date : "dd-MM-y"}}</span>
                            <span *ngIf="director.holding.typesOfHolders=='others'">{{director.holding.doCessationAsDebentureHolderOtherSecurityHolderOthers  | date : "dd-MM-y"}}</span>
                          </ng-container>
                          </td>


                          <td>
                            <ng-container *ngIf="director.holding">
                            <span *ngIf="director.holding.typesOfHolders=='individual'">{{director.holding.dateOfDebenture  | date : "dd-MM-y"}}</span>
                            <span *ngIf="director.holding.typesOfHolders=='bodyCorporate'">{{director.holding.dobDebentureHolderOtherSecurityHolder  | date : "dd-MM-y"}}</span>
                            <span *ngIf="director.holding.typesOfHolders=='others'">{{director.holding.dobDebentureHolderOtherSecurityHolderOthers  | date : "dd-MM-y"}}</span>
                          </ng-container>
                          </td>

                          <td style='white-space: nowrap'>
                            <div class="input-group">
                                  <button type="button" (click)="editmgt2detail(director._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}" style="margin-right: 10px">
                                      <span class="fa fa-pencil"></span>
                                  </button>
                             
                              <button type="button"
                                    class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}">
                             <span class="icmn-bin" ></span>
                           </button>
                          </div>
                          </td>
                      </tr>
                    </tbody>                         
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
</section>

<div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
style="top: 50px;">
<div class="modal-dialog" role="document">
<div class="modal-content">
<div class="modal-header">
  <h5 class="modal-title" id="myModalLabelForDelete">
    <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
    <i class="fa fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-sm-12">
      Are you sure you want to delete MGT-2 details?
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-danger" (click)="deletemgt2tdetail()">
    <i class="fa fa-check"></i>Yes
  </button>
  <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
    <i class="fa fa-times"></i>No
  </button>
</div>
</div>
</div>
</div>